import ButtonBase from '@ixigo/iui/ButtonBase';
import cn from '@repo/shared/utils/cn';
import type { ReactNode } from 'react';
import type { BaseCabItemOption } from '@/api';
import { CabCard, type CabCardProps } from './CabCard';
import type { CabSelectionOptions } from './index.types';

export interface CabPickerProps<
	T extends BaseCabItemOption = BaseCabItemOption,
> {
	cabSelectionOptions: CabSelectionOptions<T>;
	selectedCabId?: string;
	onChange: (cabId: string) => void;
	burnOpted?: CabCardProps['burnOpted'];
	children?: (cab: T) => ReactNode;
}

export function CabPicker<T extends BaseCabItemOption = BaseCabItemOption>({
	cabSelectionOptions,
	selectedCabId,
	onChange,
	burnOpted,
	children,
}: CabPickerProps<T>) {
	const { options: cabOptions, imageMap } = cabSelectionOptions;

	return (
		<div className="flex-1 p-20 space-y-4">
			{cabOptions.map((cab) => {
				const isSelected = cab.cabId === selectedCabId;
				return (
					<ButtonBase
						onClick={() => onChange(cab.cabId)}
						className={cn(
							'cursor-pointer w-full rounded-[15px] transition-transform duration-300 ease-in-out',
							isSelected ? 'scale-105' : 'scale-100',
						)}
						key={cab.cabId}
					>
						<CabCard
							{...cab}
							isSelected={isSelected}
							// TODO: remove this once @naveen normalizes the vehicle type
							iconUrl={imageMap[cab.vehicleType.toUpperCase()] || ''}
							burnOpted={burnOpted}
						>
							{children?.(cab)}
						</CabCard>
					</ButtonBase>
				);
			})}
		</div>
	);
}

export default CabPicker;
